module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/upload-f2f38d2a76d52da0097880e5934670fd.svg";